/*! dependencies: cash */

window.getValueAsFloat = function (value) {
  return value ? parseFloat(value.replace(',', '.')) : NaN;
};

cash.fn.isInViewport = function (offset) {
  var element = cash(this);

  if (element.length) {
    offset = typeof offset !== 'undefined' ? offset : 0;

    var windowEle = cash(window),
      elementTop = element.offset().top - offset,
      elementBottom = elementTop + element.outerHeight() + (offset * 2),
      viewportTop = windowEle.scrollTop,
      viewportBottom = viewportTop + windowEle.height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  return false;
};

window.getURLParam = function (strParamName) {
  var decodedUrl = decodeURIComponent(window.location.href);
  return getParameterFromLink(strParamName, decodedUrl);
};

window.getParameterFromLink = function (strParamName, link) {
  var strReturn = '';
  var strHref = link;
  if (strHref.indexOf('?') > -1) {
    var strQueryString = strHref.substr(strHref.indexOf('?')).toLowerCase().replace('?', '');
    var aQueryString = strQueryString.split('&');
    for (var iParam = 0; iParam < aQueryString.length; iParam++) {
      if (aQueryString[iParam].indexOf(strParamName.toLowerCase() + '=') > -1) {
        var aParam = aQueryString[iParam].split('=');
        strReturn = aParam[1];
        break;
      }
    }
  }
  return unescape(strReturn);
};

window.getAllUrlParameters = function () {
  var result = {},
    query = window.location.href.split('?')[1];

  if (query) {
    var queryArray = query.split('#')[0].split('&');

    for (var i = queryArray.length - 1; i >= 0; i--) {
      var elem = queryArray[i].split('=');
      result[elem[0]] = elem[1];
    }
  }

  return result;
};

window.updateQueryString = function (key, value, url) {
  if (!url) {
    url = window.location.href;
  }

  var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
    hash;

  var requirements =
    (typeof value !== 'undefined' && value !== null) &&
    (
      (typeof value == 'number' && value > 0) ||
      (typeof value === 'string' && value !== '') ||
      (Array.isArray(value) && value.length > 0)
    );

  if (re.test(url)) {
    if (requirements) {
      return url.replace(re, '$1' + key + '=' + value + '$2$3');
    } else {

      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
      if (typeof hash[1] !== 'undefined' && hash[1] !== null)
        url += '#' + hash[1];
      return url;
    }
  } else {
    if (requirements) {

      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = hash[0] + separator + key + '=' + value;
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1];
      }
      return url;
    } else {

      return url;
    }
  }
};

window.queryStringToObject = function () {
  var search = window.location.search.substring(1);
  return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
};

window.getHeaderHeight = function (includeSubmenu) {
  var height = cash('#header').outerHeight();

  return height;
};

window.animateScroll = function (selector, offset) {

  var element = typeof selector === 'string' ? cash(selector) : selector,
    offsetIsNumber = !isNaN(offset);

  offset = offsetIsNumber ? offset : 0;

  if (element && element[0]) {
    cash('body').data('animatingScroll', true);
    cash('html, body').animate(
      { scrollTop: element.offset().top - offset }, 'swing', function () {
        window.setTimeout(function () {
          cash('body').data('animatingScroll', false);
        }, 100);
      });
  }
};

window.isMobile = function () {
  return window.innerWidth < _mobileBreakpoint;
};

window.isFunction = function (functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
};

window.objectEquals = function (x, y) {
  'use strict';

  if (x === null || x === undefined || y === null || y === undefined) { return x === y; }
  // after this just checking type of one would be enough
  if (x.constructor !== y.constructor) { return false; }
  // if they are functions, they should exactly refer to same one (because of closures)
  if (x instanceof Function) { return x === y; }
  // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
  if (x instanceof RegExp) { return x === y; }
  if (x === y || x.valueOf() === y.valueOf()) { return true; }
  if (Array.isArray(x) && x.length !== y.length) { return false; }

  // if they are dates, they must had equal valueOf
  if (x instanceof Date) { return false; }

  // if they are strictly equal, they both need to be object at least
  if (!(x instanceof Object)) { return false; }
  if (!(y instanceof Object)) { return false; }

  // recursive object equality check
  var p = Object.keys(x);
  return Object.keys(y).every(function (i) { return p.indexOf(i) !== -1; }) &&
    p.every(function (i) { return objectEquals(x[i], y[i]); });
};
